//API
import { postRequest, putRequest, deleteRequest, getRequest } from "../globalService"

const endPoint = 'auth';

export const oauthLink = (login_hint, response_type)=> {
    return `https://api.nylas.com/oauth/authorize?client_id=1099024667628-95eug0gseqomn2n85mvnm5oebd8udtfu&redirect_uri=${process.env.REACT_APP_COACH_BASE_URL}&login_hint=${login_hint}&response_type=${response_type}`;
}


//Client
export const urlAuthNylas = (userId, email, provider)=> {
    const base = `${process.env.REACT_APP_COACH_API_BASE_URL}/${endPoint}/nylas/${userId}/${email}`;
    return provider ? `${base}/${provider}` : base;
}

//desync
export const desyncNylas = (coachId)=> {
    return postRequest(`${endPoint}/desync-nylas/${coachId}`, {}, true);
}